import { render, staticRenderFns } from "./create.vue?vue&type=template&id=64711f68&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=64711f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64711f68",
  null
  
)

export default component.exports